export default {
  common: {
    controls: {
      displayMode: {
        label: {
          notes: 'Label for the display mode control',
          message: 'Show results in',
        },
        options: {
          units: {
            notes: 'Title of the units menu item',
            message: 'Units',
          },
          monetary: {
            notes: 'Title of the monetary value menu item',
            message: 'Monetary value',
          },
        },
      },
    },
  },
  charts: {
    greaseSales: {
      header: {
        notes: 'Grease sales potential charts header',
        message: 'Grease sales potential',
      },
      controls: {
        duration: {
          notes: 'Label of the duration input',
          message: 'Cartridge duration',
        },
        price: {
          notes: 'Label of the price input',
          message: 'Price per grease cartridge',
        },
      },
    },
    toolSales: {
      header: {
        notes: 'Tool sales potential charts header',
        message: 'Tool sales potential',
      },
      controls: {
        duration: {
          notes: 'Label of the duration input',
          message: 'Tool duration',
        },
        price: {
          notes: 'Label of the price input',
          message: 'Price per tool',
        },
      },
    },
    workHours: {
      header: {
        notes: 'Work hours charts header',
        message: 'Work hours',
      },
    },
    serviceLogs: {
      header: {
        notes: 'Service logs charts header',
        message: 'Service logs',
      },
      expectedBar: {
        notes: 'Service logs entered bar name',
        message: 'Service logs expected',
      },
      enteredBar: {
        notes: 'Service logs expected bar name',
        message: 'Service logs entered',
      },
    },
  },
  notAvailable: {
    header: {
      notes: 'Header of message shown when insights are not available',
      message: 'Insights are not yet available for this equipment',
    },
  },
  linerWear: {
    currentPlotLabel: {
      notes: 'Label of the plot showing wear on current liners set',
      message: 'Current',
    },
    yLabel: {
      notes: 'Label for y-axis in liner wear chart',
      message: 'A-dimension',
    },
    xLabel: {
      notes: 'Label for x-axis in liner wear chart',
      message: 'Loaded hours',
    },
    action: {
      configureThreshold: {
        notes: 'Action to configure thresholds for liner wear',
        message: 'Set threshold',
      },
    },
    thresholdAlert: {
      notes:
        'Information that thresholds are not configured for equipment, thus no alarms are created.',
      message:
        'Alarms for A-dimension or loaded hours will not be triggered unless thresholds are set.',
    },
  },
};
